import script from "./PinPost.vue?vue&type=script&setup=true&lang=js"
export * from "./PinPost.vue?vue&type=script&setup=true&lang=js"

import "./PinPost.vue?vue&type=style&index=0&id=a5ff8b20&lang=scss"

const __exports__ = script;

export default __exports__